/**
 * Width limits of the editor's right side panel (object and animation tools), in px.
 *
 * Below the minimum its two-column rows no longer fit their fields; above the maximum the
 * fields only grow wider for nothing, taking room from the canvas. Enforced with CSS on the
 * panel's split pane, so they hold when the window is resized too — not only while the
 * divider is dragged.
 */
export const RIGHT_PANEL_MIN_WIDTH = 300
export const RIGHT_PANEL_MAX_WIDTH = 520

/** What the canvas + timeline side of the editor keeps at least, while the divider is dragged. */
export const MAIN_PANE_MIN_WIDTH = 480

/** Class names of the two panes of the editor's top-level split (see pages/Editor.tsx). */
export const MAIN_PANE_CLASS = "editor-main-pane"
export const RIGHT_PANE_CLASS = "editor-right-pane"
